import { Colors, FindLoad, Images } from 'utils';
import { buttonsStyle } from './styles';
import { MinLoader } from '../loader';
import React from 'react';

export const AddCircleBlue = ({ text, handleClick, type, disabled, styles, icon, actionType }) => {
    const classes = buttonsStyle();
    const loader = FindLoad(actionType);

    return (
        <button
            type={type ? type : 'button'}
            className={classes.addCircleBtn}
            onClick={handleClick}
            style={{ ...styles }}
            disabled={disabled}
        >
            {loader?.length ? (
                <div style={{ marginRight: '8px' }}>
                    <MinLoader margin={'0'} width={'14px'} height={'14px'} color={Colors.ThemeBlue} position={'relative'} />
                </div>
            ) : (
                <img src={icon ? icon : Images.addHours} alt="icon" />
            )}
            {text}
        </button>
    );
};
